import { KoButton } from 'packages';
import KoIcon from '@kwapio/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { DEFAULT_RELEASE_FLOW } from '../constants';
import styles from './releases.module.scss';

const FLOW_ICON_MAP = {
  'pull-requests': 'PullRequestOutlined',
  'qa-testing': 'CheckCircleOutlined',
  'uat-sign-off': 'FileDoneOutlined',
  'release-gate': 'LockOutlined',
  'release-notes': 'FileTextOutlined'
};

const FLOW_PATH_MAP = {
  'pull-requests': 'pull-requests',
  'qa-testing': 'qa',
  'uat-sign-off': 'uat',
  'release-gate': 'gate',
  'release-notes': 'release-notes'
};

function buildTabs(releaseFlow) {
  const flow = releaseFlow || DEFAULT_RELEASE_FLOW;
  const tabs = [{ key: 'overview', label: 'Overview', icon: 'DashboardOutlined' }];

  flow.forEach((step, idx) => {
    const slug = step.label.toLowerCase().replace(/\s+/g, '-');
    const path = FLOW_PATH_MAP[slug] || slug;
    const icon = FLOW_ICON_MAP[slug] || 'AppstoreOutlined';
    tabs.push({
      key: path,
      label: `${idx + 1}. ${step.label}`,
      icon
    });
  });

  return tabs;
}

function ReleaseSubNav({ activeKey, releaseFlow }) {
  const { releaseId, workspaceId } = useParams();
  const navigate = useNavigate();

  const basePath = workspaceId
    ? `/workspace/${workspaceId}/development/release`
    : '/release';

  const tabs = buildTabs(releaseFlow);

  return (
    <div className={styles.subNav}>
      {tabs.map((tab) => (
        <KoButton
          key={tab.key}
          type={activeKey === tab.key ? 'primary' : 'text'}
          label={tab.label}
          icon={<KoIcon name={tab.icon} width={14} height={14} />}
          onClick={() => navigate(`${basePath}/${releaseId}/${tab.key}`)}
          className={styles.subNavBtn}
        />
      ))}
    </div>
  );
}

export default ReleaseSubNav;
